import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router } from '@angular/router';
import { HomeComponent } from '../pages/learner/home/home.component';
import { TeamAdminHomeComponent } from '../pages/team-admin/team-admin-home/team-admin-home.component';
import { LoggerService } from '../services/logger/logger.service';
import { SseService } from '../services/sse.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const logger = inject(LoggerService);
  const sseService = inject(SseService);
  const url = state.url;
  const queryParams = route.queryParams;
  console.log(`authGuard url: ${url}`)
  if (url === '/logout') {
    const returnUrl = localStorage.getItem('returnUrl');
    localStorage.clear();
    // Restore the returnUrl
    if (returnUrl) {
      localStorage.setItem('returnUrl', returnUrl);
    }

    // Clear currently set user for Sentry
    logger.clearUser();
    window.location.replace('/login');
    return true;
  }

  if (url === '/login') {
    return true;
  }

  if (url.startsWith('/login') && queryParams['error_code'] === '400') {
    return true;
  }

  if (url.startsWith('/login-callback') && url.length > '/login-callback'.length) {
    return true;
  }

  const rolesExist = !!localStorage.getItem('roles');
  if (!rolesExist) {
    sseService.disconnectAll();
    console.error(`No roles set on route ${url}`)
    localStorage.setItem('returnUrl', state.url);
    window.location.replace('/login');
    return false;
  }

  if (!route.component) {
    console.error(`No component on route ${url}`)
    return false;
  }
  const componentName = route.component.name;
  if (componentName === HomeComponent.name) {
    console.log(`TODO: Learner URLs validation`)
  }

  if (componentName === TeamAdminHomeComponent.name) {
    console.log(`TODO: Team admin URLs validation`)
  }

  return true;
};
